/**
 * 내 업무 홈 가상 데이터 (B′ 미리보기 전용). Firestore 와 무관 — 화면 모양 확인용.
 * 금액은 ● 로 가린 문자열만 둔다(실제 숫자처럼 보이지 않게).
 * 경원 생산 카드·일정은 2026-10-22 부터 OKIS 미러 실데이터(useAsconShipments·useAsconProdDays) — 가상 자료는 ?ascon=mock 일 때만.
 */
import type { TenantKey } from "@/domain/space";

/** 결재 대기(가상) — 결재 기능이 아직 없다. 할 일은 실제 개인 할 일(personal_events kind "todo")을 쓴다. */
export interface MockApproval {
  id: string;
  tenant: TenantKey;
  title: string;
}

export const MOCK_APPROVALS: MockApproval[] = [
  { id: "a1", tenant: "joongang", title: "휴가 신청 결재 1건" },
  { id: "a2", tenant: "gyeongwon", title: "유류비 지출 결의 1건" },
];

/** 관리자 "관리" 블록 — 전사 결재 대기 수(가상) */
export const MOCK_ADMIN_APPROVALS: Record<TenantKey, number> = { joongang: 3, gyeongwon: 1 };
